import React from 'react';
import PropTypes from 'prop-types';
import { shouldUpdate } from 'recompose';
import TimelineAvailability from '../../../containers/DailyPlanning/TimelineAvailability/TimelineAvailabilityContainer';
import gradePropTypes from '../../../propTypes/entities/grade';

class TimelineRow extends React.Component {
  getClinicianRowStyle = () => ({ width: `${this.props.dayWidth}px` });

  render() {
    const { availabilities, clinicianGrade, canAllocateWork, dayStart, postingId, clinicianId, dayEnd } = this.props;
    const clinicianAvailabilities = availabilities.map((el, i) => (
      <TimelineAvailability
        key={`timelineAvailabilities${el.id}${dayStart}`}
        availabilityId={el.id}
        first={el.isFirst}
        previousItemEnd={el.isFirst ? dayStart : availabilities[i - 1].endDate}
        clinicianGrade={clinicianGrade}
        postingId={el.postingId}
        canAllocateWork={canAllocateWork}
        clinicianId={clinicianId}
        schedulerModeStartTime={dayStart}
        schedulerModeEndTime={dayEnd}
      />
    ));

    return (
      <li id={`timelinePostingId${postingId}`} className="clinician-row" style={this.getClinicianRowStyle()}>
        {clinicianAvailabilities}
      </li>
    );
  }
}

TimelineRow.propTypes = {
  canAllocateWork: PropTypes.bool.isRequired,
  clinicianGrade: gradePropTypes.isRequired,
  availabilities: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.start,
      end: PropTypes.string,
      id: PropTypes.number,
    }),
  ).isRequired,
  dayWidth: PropTypes.number.isRequired,
  dayStart: PropTypes.string.isRequired,
  dayEnd: PropTypes.string.isRequired,
  postingId: PropTypes.number.isRequired,
  clinicianId: PropTypes.number.isRequired,
};

TimelineRow.defaultProps = {
  clinicianName: 'No full name',
  clinicianBand: 'No band set',
  availabilities: [],
};

const checkPropsChange = (props, nextProps) =>
  true ||
  props.postingId !== nextProps.postingId ||
  props.clinicianId !== nextProps.clinicianId ||
  props.dayStart !== nextProps.dayStart ||
  props.dayWidth !== nextProps.dayWidth;

export default shouldUpdate(checkPropsChange)(TimelineRow);
